export const  ACTIONS = {
    NOTIFY : 'NOTIFY',
    AUTH: 'AUTH',
    PRODUCTS:'PRODUCTS',
    ADD_DAILIES:"DAILIES",
    ADD_CART:'ADD_CART',
    ADD_MODAL:'ADD_MODAL',
    ADD_ORDERS:'ADD_ORDERS',
    ADD_USERS:'ADD_USERS',
    ADD_CATEGORIES:'ADD_CATEGORIES',
    ADD_NUTRIENTS:'ADD_NUTRIENTS',
    
}